
export const usartPinCodeTemplate = `pmx_config({name}, {signal});`;


    

export const usartCodeTemplate = 
`

#include "driver_usart.h"
#include "driver_pinmux.h"
/*!
    \\brief      user USART configure function
    \\param[in]  none
    \\param[out] none
    \\retval     none
*/
int mx_usart_init(void)
{
    // pinmux的函数模板
    {pinsCode}
    // 
    usart_word_length_set({instance}, {WordLength});
    usart_stop_bit_set({instance}, {StopBits});
    usart_parity_config({instance}, {Parity});
    usart_baudrate_set({instance}, {BaudRate}U);
    usart_rx_tx_config({instance}, {Mode});
    usart_oversample_config({instance}, {OverSampling});
    /* configure USART hardware flow */
    usart_hardware_flow_config({instance}, {HwFlowCtl});
    usart_enable({instance});
}


`;

